import React, {useEffect, useState} from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {isMobile} from 'react-device-detect'
import axios from 'axios'
import Pagination from 'react-js-pagination'
import {TextSub} from '../components/TextSub'
// @ts-ignore
import LinesEllipsis from 'react-lines-ellipsis'
import moment from 'moment/moment'

export function PlaceMessage() {

  const [loading, setLoading] = useState(true)
  const [places, setPlaces] = useState<any>([])

  const [placeId, setPlaceId] = useState(0)
  const [userId, setUserId] = useState(0)
  const [guestId, setGuestId] = useState(0)

  const [currentPage, setCurrentPage] = useState(0)
  const [perPage, setPerPage] = useState(0)
  const [total, setTotal] = useState(0)

  useEffect(() => {
    getPlaces(0, 0, 0, 1)
    return () => {

    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const onSearch = () => {
    getPlaces(placeId, userId, guestId, 1)
  }

  const handlePageChange = (page: number) => {
    getPlaces(placeId, userId, guestId, page)
  }

  const getPlaces = (placeId = 0, userId = 0, guestId = 0, page = 1) => {
    setPlaces([])
    setLoading(true)
    setCurrentPage(0)
    setPerPage(0)
    setTotal(0)
    axios.get(`${process.env.REACT_APP_API2_URL}am/place/message?page=${page}&placeId=${placeId}&userId=${userId}&guestId=${guestId}`).then(({data: {error, time, result}}) => {
      console.log(time)
      console.log(result)
      if (error !== '') {
      } else {
        setPlaces(result.places.data)
        setCurrentPage(result.places.current_page)
        setPerPage(result.places.per_page)
        setTotal(result.places.total)

        window.scrollTo(0, 0)
      }
      setLoading(false)
    }).catch((error) => {
      console.log(error)
      setLoading(false)
    })
  }

  return <>
    <PageTitle breadcrumbs={[]}>메시지</PageTitle>
    <div style={{
      padding: isMobile ? 4 : 20,
      borderRadius: isMobile ? 4 : 20,
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    }}>
      <div style={{
        borderRadius: 20,
        backgroundColor: 'white',
        width: '100%',
      }}>

        <div style={{
          marginTop: 10,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
          <input
            type='text'
            className='form-control'
            placeholder='장소 번호'
            value={placeId}
            style={{
              flex: 1, width: '25%'
            }}
            onChange={(e) => {
              setPlaceId(Number(e.target.value))
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
              }
            }}
          />
          <input
            type='text'
            className='form-control'
            placeholder='호스트 번호'
            value={userId}
            style={{
              flex: 1, width: '25%', marginLeft: 10
            }}
            onChange={(e) => {
              setUserId(Number(e.target.value))
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
              }
            }}
          />
          <input
            type='text'
            className='form-control'
            placeholder='게스트 번호'
            value={guestId}
            style={{
              flex: 1, width: '25%', marginLeft: 10
            }}
            onChange={(e) => {
              setGuestId(Number(e.target.value))
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
              }
            }}
          />
          <label onClick={() => {
            onSearch()
          }} style={{
            width: 100, marginLeft: 5
          }} className='btn btn-dark'>검색</label>
        </div>
      </div>

      {
        loading ?
          <div style={{
            width: '100%',
            height: 400,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <span className='indicator-progress' style={{display: 'block'}}>Loading...<span className='spinner-border spinner-border-sm align-middle ms-2' /></span>
          </div>
          :
          <div style={{
            width: '100%',
          }}>
            {
              places.map((place: any, index: number) => {
                return (
                  <div style={{marginTop: 16, padding: 20, width: '100%', borderRadius: 10, border: '1px solid #DDD'}}>
                    <div style={{marginTop: 10, paddingBottom: 10, borderBottom: '1px solid #EEE'}}>
                      <table style={{width: '100%'}}>
                        <colgroup>
                          <col width={'100px'} />
                          <col width={'auto'} />
                        </colgroup>
                        <tbody>
                        <tr>
                          <td rowSpan={2}>
                            <div style={{width: 100, height: 100, position: 'relative'}}>
                              <img src={place.place_image_url} alt='장소 이미지' style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10}} />
                              <div
                                style={{
                                  position: 'absolute',
                                  width: 30,
                                  height: 30,
                                  borderTopLeftRadius: 8,
                                  bottom: 0,
                                  right: 0,
                                  backgroundColor: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <h4 style={{margin: 0}}>{place.place_grade}</h4>
                              </div>
                            </div>
                          </td>
                          <td style={{verticalAlign: 'top', textAlign: 'left'}}>
                            <div style={{marginLeft: 10}}>
                              <LinesEllipsis text={`${place.place_id}. ${place.place_title}`} maxLine='2' ellipsis='...' trimRight basedOn='letters' style={{fontSize: 20, fontWeight: 'bold'}} />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style={{verticalAlign: 'top', textAlign: 'left'}}>
                            <div style={{marginLeft: 10, marginTop: 10}}>
                              <TextSub title={'촬영 건수'} subTitle={`${place.place_shoot_count.toLocaleString('en')} (${place.place_booking_count.toLocaleString('en')})`} marginTop={-10} />
                              <TextSub title={'카테고리'} subTitle={`${place.place_category_main} > ${place.place_category_sub}`} marginTop={-10} />
                              <TextSub title={'결제방식'} subTitle={place.payments_type === 0 ? '승인 결제(나중결제)' : place.payments_type === 1 ? '바로 결제' : '승인 결제(미리결제)'} marginTop={-10} />
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style={{marginTop: 10, paddingBottom: 10, borderBottom: '1px solid #EEE'}}>
                      <table style={{width: '100%'}}>
                        <colgroup>
                          <col width={'100px'} />
                          <col width={'auto'} />
                        </colgroup>
                        <tbody>
                        <tr>
                          <td>
                            <div style={{width: 100, height: 100, position: 'relative'}}>
                              <img src={place.host_image_url} alt='호스트 이미지' style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10}} />
                            </div>
                          </td>
                          <td style={{verticalAlign: 'top', textAlign: 'left'}}>
                            <div style={{marginLeft: 10}}>
                              {place.host_black === 1 && <p style={{color: 'red'}}>{place.host_black_comment}</p>}

                              <h1>{place.s_user_id}. 호스트</h1>
                              <TextSub title={'닉네임 (이름)'} subTitle={`${place.host_name} (${place.host_real_name})`} marginTop={0} />

                              <TextSub title={'나이'} subTitle={`만 ${Math.floor(moment.duration(moment(moment().format('YYYYMMDD')).diff(moment(place.host_birth))).asYears())}세`} marginTop={-10} />
                              <TextSub title={'전화번호'} subTitle={place.host_phone} marginTop={-10} />
                              <TextSub title={'이메일'} subTitle={place.host_email} marginTop={-10} />
                              <TextSub title={'가입일'} subTitle={`${place.host_created_at}, ${moment.duration(moment(moment().format('YYYY-MM-DD')).diff(place.host_created_at)).asDays()} 일전`} marginTop={-10} />
                              <TextSub
                                title={'마지막 활성 시간'}
                                subTitle={`${moment(place.host_last_logined_at).format('MM-DD')}, ${Math.floor(
                                  (moment.duration(moment().diff(moment(place.host_last_logined_at, 'YYYY-MM-DD'))).asDays() * 100) / 100
                                )} 일전`}
                                marginTop={-10}
                              />
                              {place.host_memo !== undefined && place.host_memo.length > 0 && <TextSub title={'메모'} subTitle={place.host_memo} marginTop={-10} />}
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <div style={{marginTop: 10, paddingBottom: 10, borderBottom: '1px solid #EEE'}}>
                      <table style={{width: '100%'}}>
                        <colgroup>
                          <col width={'100px'} />
                          <col width={'auto'} />
                        </colgroup>
                        <tbody>
                        <tr>
                          <td>
                            <div style={{width: 100, height: 100, position: 'relative'}}>
                              <img src={place.guest_image_url} alt='게스트 이미지' style={{width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10}} />
                              <div
                                style={{
                                  position: 'absolute',
                                  width: 30,
                                  height: 30,
                                  borderTopLeftRadius: 8,
                                  bottom: 0,
                                  right: 0,
                                  backgroundColor: 'white',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              >
                                <h4 style={{margin: 0}}>{place.guest_grade}</h4>
                              </div>
                            </div>
                          </td>
                          <td style={{verticalAlign: 'top', textAlign: 'left'}}>
                            <div style={{marginLeft: 10}}>
                              {place.guest_black === 1 && (
                                <p
                                  style={{
                                    color: 'red',
                                  }}
                                >
                                  {place.guest_black_comment}
                                </p>
                              )}

                              <div style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
                                <h1>{place.s_guest_id}. 게스트</h1>
                                {place.guest_bet > -1 && (
                                  <div style={{display: 'flex', flexDirection: 'row'}}>
                                    <div style={{fontSize: 19, fontWeight: 500}}>&nbsp;/ ({place.guest_bet},</div>
                                    <div
                                      style={{
                                        marginTop: 3,
                                        marginBottom: 0,
                                        marginRight: 6,
                                        marginLeft: 6,
                                        width: 14,
                                        height: 14,
                                        borderRadius: 8,
                                        cursor: 'pointer',
                                        backgroundColor: place.guest_bet_last === 100 ? '#18e318' : place.guest_bet_last === 50 ? '#e0e01b' : '#d21616',
                                      }}
                                    />
                                    <div style={{fontSize: 19, fontWeight: 500}}>)</div>
                                  </div>
                                )}
                              </div>

                              <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                                <div>
                                  <TextSub title={'닉네임 (이름)'} subTitle={`${place.guest_name} (${place.guest_real_name})`} marginTop={0} />
                                </div>
                              </div>

                              <TextSub title={'나이'} subTitle={`만 ${Math.floor(moment.duration(moment(moment().format('YYYYMMDD')).diff(moment(place.guest_birth))).asYears())}세`} marginTop={-10} />
                              <TextSub title={'전화번호'} subTitle={place.guest_phone} marginTop={-10} />
                              <TextSub title={'이메일'} subTitle={place.guest_email} marginTop={-10} />
                              <TextSub title={'추가정보'} subTitle={place.guest_company} marginTop={-10} />
                              <TextSub
                                title={'마지막 활성 시간'}
                                subTitle={`${moment(place.guest_last_logined_at).format('MM-DD')}, ${Math.floor(
                                  (moment.duration(moment().diff(moment(place.guest_last_logined_at, 'YYYY-MM-DD'))).asDays() * 100) / 100
                                )} 일전`}
                                marginTop={-10}
                              />
                              {place.guest_statistic !== undefined && place.guest_statistic !== null && (
                                <>
                                  <TextSub title={'총 결제금액'} subTitle={place.guest_statistic.booking_guest_price.toLocaleString('en')} marginTop={-10} />
                                  <TextSub
                                    title={'촬영 진행률'}
                                    subTitle={`${
                                      place.guest_statistic.guest_booking_completed_count > 0 && place.guest_statistic.guest_proceeding_booking > 0
                                        ? Math.floor((place.guest_statistic.guest_booking_completed_count / place.guest_statistic.guest_proceeding_booking) * 100)
                                        : 0
                                    }% (${place.guest_statistic.guest_booking_completed_count} / ${place.guest_statistic.guest_proceeding_booking})`}
                                    marginTop={-10}
                                  />
                                </>
                              )}
                              {place.guest_memo !== undefined && place.guest_memo.length > 0 && <TextSub title={'메모'} subTitle={place.guest_memo} marginTop={-10} />}
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <label
                      onClick={() => {
                        window.open(`/place/message/${place.message_id}`, '_blank')
                      }}
                      style={{marginTop: 20}}
                      className='btn btn-sm btn-primary'
                    >
                      메시지 보기
                    </label>
                  </div>
                )
              })
            }
          </div>
      }

      <div style={{marginTop: 20}}>
        <Pagination activePage={currentPage}
                    itemsCountPerPage={perPage}
                    totalItemsCount={total}
                    pageRangeDisplayed={10}
                    prevPageText={'‹'}
                    nextPageText={'›'}
                    onChange={handlePageChange} />
      </div>
    </div>
  </>
}

